export enum ConsumptionTypes {
  POUND = 'pound',
  KWH = 'kWh',
}
